/**
 * 修复变体选择器中CSS选择器特殊字符问题
 * 这个脚本会重写Element.prototype.querySelectorAll方法来安全处理包含特殊字符的CSS选择器
 */

(function () {
  "use strict";

  // 使用自定义查找逻辑替代有问题的CSS选择器
  function findElementsWithValue(container, selector, value) {
    const elements = [];

    if (selector.includes('input[type="radio"]')) {
      // 查找所有input[type="radio"]元素
      const radioInputs = container.querySelectorAll(`input[type="radio"]`);
      for (const input of radioInputs) {
        if (input.value === value) {
          // 检查是否符合其他条件
          if (
            selector.includes(":not([xo-for-quick-view])") &&
            input.hasAttribute("xo-for-quick-view")
          ) {
            continue;
          }
          elements.push(input);
        }
      }
    }

    if (selector.includes("select")) {
      // 查找所有select元素
      const selects = container.querySelectorAll(`select`);
      for (const select of selects) {
        if (select.value === value) {
          // 检查是否符合其他条件
          if (
            selector.includes(":not([xo-for-quick-view])") &&
            select.hasAttribute("xo-for-quick-view")
          ) {
            continue;
          }
          elements.push(select);
        }
      }
    }

    return elements;
  }

  // 检查选择器是否是我们需要特殊处理的变体选择器
  function isVariantSelector(selector) {
    // 检查是否包含input[type="radio"]或select
    const hasInputOrSelect =
      selector.includes('input[type="radio"]') || selector.includes("select");

    // 检查是否包含[value="..."]模式
    const hasValueAttribute = selector.includes('[value="');

    // 检查value值中是否包含可能导致CSS语法错误的字符
    const hasProblematicChars =
      selector.includes('" ') || // 双引号后跟空格
      selector.includes('"L') || // 双引号后跟字母
      selector.includes('"W') ||
      selector.includes('"H') ||
      selector.match(/\[value="[^"]*"[^"\]]/); // 双引号后还有非引号非括号字符

    return hasInputOrSelect && hasValueAttribute && hasProblematicChars;
  }

  // 解析变体选择器以提取value
  function parseVariantSelector(selector) {
    // 手动解析value，因为它可能包含双引号
    const valueStart = selector.indexOf('[value="');
    if (valueStart !== -1) {
      const contentStart = valueStart + 8; // '[value="'.length

      // 查找匹配的结束引号，考虑到可能有未转义的双引号
      let contentEnd = -1;
      let bracketCount = 0;

      for (let i = contentStart; i < selector.length; i++) {
        const char = selector[i];

        if (char === "[") {
          bracketCount++;
        } else if (char === "]") {
          if (bracketCount === 0) {
            contentEnd = i - 1; // -1 因为我们要排除最后的引号
            break;
          }
          bracketCount--;
        }
      }

      if (contentEnd > contentStart) {
        const value = selector.substring(contentStart, contentEnd);
        return {
          selector: selector,
          value: value,
        };
      }
    }

    return null;
  }

  // 保存原始的querySelector和querySelectorAll方法
  const originalQuerySelector = Element.prototype.querySelector;
  const originalQuerySelectorAll = Element.prototype.querySelectorAll;

  // 重写querySelectorAll方法
  Element.prototype.querySelectorAll = function (selector) {
    try {
      // 首先尝试使用原始选择器
      return originalQuerySelectorAll.call(this, selector);
    } catch (error) {
      // 如果出现语法错误，检查是否是变体选择器
      if (error.name === "SyntaxError" && isVariantSelector(selector)) {
        try {
          const parsed = parseVariantSelector(selector);
          if (parsed) {
            const elements = findElementsWithValue(
              this,
              parsed.selector,
              parsed.value
            );
            return elements;
          }
        } catch (secondError) {
          // 静默处理错误
        }
      }

      // 如果不是我们能处理的错误，返回空数组
      return [];
    }
  };

  // 重写querySelector方法
  Element.prototype.querySelector = function (selector) {
    try {
      // 首先尝试使用原始选择器
      return originalQuerySelector.call(this, selector);
    } catch (error) {
      // 如果出现语法错误，检查是否是变体选择器
      if (error.name === "SyntaxError" && isVariantSelector(selector)) {
        try {
          const parsed = parseVariantSelector(selector);
          if (parsed) {
            const elements = findElementsWithValue(
              this,
              parsed.selector,
              parsed.value
            );
            return elements.length > 0 ? elements[0] : null;
          }
        } catch (secondError) {
          // 静默处理错误
        }
      }

      // 如果不是我们能处理的错误，返回null
      return null;
    }
  };

  // 同样修复document.querySelector和querySelectorAll
  const originalDocumentQuerySelector = Document.prototype.querySelector;
  const originalDocumentQuerySelectorAll = Document.prototype.querySelectorAll;

  Document.prototype.querySelector = function (selector) {
    try {
      return originalDocumentQuerySelector.call(this, selector);
    } catch (error) {
      if (error.name === "SyntaxError" && isVariantSelector(selector)) {
        try {
          const parsed = parseVariantSelector(selector);
          if (parsed) {
            const elements = findElementsWithValue(
              this,
              parsed.selector,
              parsed.value
            );
            return elements.length > 0 ? elements[0] : null;
          }
        } catch (secondError) {
          // 静默处理错误
        }
      }

      return null;
    }
  };

  Document.prototype.querySelectorAll = function (selector) {
    try {
      return originalDocumentQuerySelectorAll.call(this, selector);
    } catch (error) {
      if (error.name === "SyntaxError" && isVariantSelector(selector)) {
        try {
          const parsed = parseVariantSelector(selector);
          if (parsed) {
            const elements = findElementsWithValue(
              this,
              parsed.selector,
              parsed.value
            );
            return elements;
          }
        } catch (secondError) {
          // 静默处理错误
        }
      }
      return [];
    }
  };
})();
